export class NotificationState {
  list: string[];

  constructor() {
    this.list = [];
  }
}
